import { initComponents } from "./../utils/initComponents";
import Header from "./../components/Header";
import HomeHero from "./../components/HomeHero";
import ScrollingPromoFeature from "./../components/ScrollingPromoFeature";
import StatGrid from "./../components/StatGrid";
import PeopleFeature from "./../components/PeopleFeature";
import Timeline from "./../components/Timeline";
import Accordion from "./../components/Accordion";
import Carousel from "./../components/Carousel";
import Tabs from "./../components/Tabs";
import FooterCTA from "./../components/FooterCTA";
import Modal from "./../components/Modal";
import PostIndex from "./../components/PostIndex.vue";
import ArchiveIndex from "./../components/ArchiveIndex.vue";
import { createApp } from "vue";

// global variables
window.breakpoint = 992;

const APP = {};
APP.helpers = {
  initComponents: (elem) => initComponents(elem, APP),
};

/**
 * Page components
 * <elem data-component="<component name>">
 */
APP.components = {
  Header: (elem) => new Header(elem, APP).init(),
  HomeHero: (elem) => new HomeHero(elem, APP).init(),
  ScrollingPromoFeature: (elem) => new ScrollingPromoFeature(elem, APP).init(),
  StatGrid: (elem) => new StatGrid(elem, APP).init(),
  PeopleFeature: (elem) => new PeopleFeature(elem, APP).init(),
  Timeline: (elem) => new Timeline(elem, APP).init(),
  Accordion: (elem) => new Accordion(elem, APP).init(),
  Carousel: (elem) => new Carousel(elem, APP).init(),
  Tabs: (elem) => new Tabs(elem, APP).init(),
  FooterCTA: (elem) => new FooterCTA(elem, APP).init(),
  Modal: (elem) => new Modal(elem, APP).init(),
};

// Vue
if (document.querySelector("#vue-post-index")) {
  const container = createApp(PostIndex);
  container.mount("#vue-post-index");
}

if (document.querySelector("#vue-archive-index")) {
  const container = createApp({});
  container.component("archive-index", ArchiveIndex);
  container.mount("#vue-archive-index");
}

export default APP;
